/* APH_BS_5UP_20260802 */
/**
 * APH theme UI - qty steppers, bulk tiers, accordion, hero swiper, chips.
 * Cart/checkout stay on Shopify/Dawn AJAX. No catalogue hardcoding.
 * Includes demos price odometer (digit reel) for bulk Buy 1/2/3.
 */
(function () {
  'use strict';

  window.APH = window.APH || {};
  window.APH.currency = window.APH.currency || { code: 'GBP', symbol: '£', rate: 1 };

  /* --- Price odometer (demos shared/script.js) - digit reel on bulk tier change --- */
  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  /* Some contexts (cart drawer line prices) have a blanket
     `.cart-item__price-row *{display:inline!important}` reset that cascades
     through every nested node the odometer builds regardless of how
     specific a competing CSS rule is written (tried a higher-specificity
     override first — kept losing for reasons not fully pinned down even with
     matching specificity math, possibly stylesheet load-order edge cases).
     Setting these via inline style + 'important' priority sidesteps the
     fight entirely: an inline !important always wins over any external
     stylesheet rule, full stop — Harry 2026-08-05. */
  function setImportant(el, prop, value) {
    el.style.setProperty(prop, value, 'important');
  }

  function buildDigitStrip() {
    var strip = document.createElement('span');
    strip.className = 'od-strip';
    setImportant(strip, 'display', 'block');
    for (var i = 0; i <= 9; i++) {
      var n = document.createElement('span');
      n.textContent = String(i);
      setImportant(n, 'display', 'flex');
      setImportant(n, 'align-items', 'center');
      setImportant(n, 'justify-content', 'center');
      strip.appendChild(n);
    }
    return strip;
  }

  function ensureOdometer(el) {
    if (!el || el.getAttribute('data-odometer') === '1') return;
    /* Compare-at / was-price: a reel on the smaller strikethrough stacked
       digits on mobile. Keep that as plain text. */
    if (el.closest('.price-compare, .upsell-price-was')) return;
    el.setAttribute('data-odometer', '1');
    el.classList.add('price-odometer');
    el.setAttribute('aria-live', 'polite');
    setImportant(el, 'display', 'inline-flex');
    setImportant(el, 'align-items', 'center');
  }

  function renderOdometerFrame(el, value) {
    var symbol = (window.APH.currency && window.APH.currency.symbol) || '£';
    var rate = (window.APH.currency && window.APH.currency.rate) || 1;
    var display = value * rate;
    var fixed = (Math.round(display * 100) / 100).toFixed(2);
    var parts = fixed.split('.');
    var chars = (symbol + parts[0] + '.' + parts[1]).split('');

    if (!el._odRoot) {
      el.textContent = '';
      el._odRoot = document.createElement('span');
      el._odRoot.className = 'od-root';
      setImportant(el._odRoot, 'display', 'inline-flex');
      setImportant(el._odRoot, 'align-items', 'center');
      el.appendChild(el._odRoot);
    }
    var root = el._odRoot;
    while (root.childNodes.length > chars.length) {
      root.removeChild(root.lastChild);
    }
    /* Pixel height for strip steps - WKWebView can drop calc(n * em) transforms.
       Always derive from --od-h × font-size. Never measure an existing .od-digit
       rect: that drifts (padding / leftover inline height) vs the 0-9 spans,
       which stacked sale digits on 390. */
    var hVar = getComputedStyle(el).getPropertyValue('--od-h').trim() || '1.25em';
    var fs = parseFloat(getComputedStyle(el).fontSize) || 16;
    var hPx = hVar.indexOf('em') !== -1 ? parseFloat(hVar) * fs : parseFloat(hVar);
    if (!hPx || !isFinite(hPx)) hPx = fs * 1.25;

    chars.forEach(function (ch, i) {
      var col = root.childNodes[i];
      if (!col) {
        col = document.createElement('span');
        root.appendChild(col);
      }
      if (/\d/.test(ch)) {
        if (col.className !== 'od-digit') {
          col.className = 'od-digit';
          col.textContent = '';
          setImportant(col, 'display', 'inline-block');
          setImportant(col, 'overflow', 'hidden');
          setImportant(col, 'height', (hPx || 20) + 'px');
          setImportant(col, 'max-height', (hPx || 20) + 'px');
          col.appendChild(buildDigitStrip());
        } else if (hPx) {
          setImportant(col, 'height', hPx + 'px');
          setImportant(col, 'max-height', hPx + 'px');
          setImportant(col, 'overflow', 'hidden');
        }
        var strip = col.firstChild;
        if (strip) {
          /* Demos-exact: never set transition inline — the CSS .od-strip
             transition (transform .5s cubic-bezier) IS the reel motion. */
          var digit = parseInt(ch, 10);
          var spans = strip.children;
          var si;
          for (si = 0; si < spans.length; si++) {
            setImportant(spans[si], 'height', hPx + 'px');
            setImportant(spans[si], 'max-height', hPx + 'px');
            setImportant(spans[si], 'line-height', hPx + 'px');
          }
          strip.style.transform = 'translateY(' + (-digit * hPx) + 'px)';
        }
      } else {
        if (col.className !== 'od-char') {
          col.className = 'od-char';
          col.textContent = ch;
          setImportant(col, 'display', 'inline-flex');
          setImportant(col, 'align-items', 'center');
          setImportant(col, 'justify-content', 'center');
        } else if (col.textContent !== ch) {
          col.textContent = ch;
        }
      }
    });
  }

  /**
   * Animate price display to toGbp (usually LINE total for bulk tiers).
   * When data-unit-gbp is set, does not overwrite data-gbp (unit stays for ATC).
   */
  window.APH.animatePrice = function (el, toGbp, opts) {
    if (!el) return;
    opts = opts || {};
    var duration = opts.duration != null ? opts.duration : 480;
    ensureOdometer(el);
    /* Prefer previous display value - never from data-line-gbp (set to target first) */
    var from =
      el._odValue != null
        ? el._odValue
        : parseFloat(el.getAttribute('data-gbp')) || 0;
    var to = Math.round(toGbp * 100) / 100;
    if (el._odRaf != null) {
      (el._odCancelRaf || cancelAnimationFrame)(el._odRaf);
    }
    el._odRaf = null;
    if (!el.getAttribute('data-unit-gbp')) {
      el.setAttribute('data-gbp', to.toFixed(2));
    }
    if (Math.abs(from - to) < 0.001 || duration === 0) {
      el._odAnimating = false;
      el._odValue = to;
      renderOdometerFrame(el, to);
      return;
    }
    el._odAnimating = true;
    var start = performance.now();
    /* Demos-exact: requestAnimationFrame drives the target updates, the CSS
       .od-strip transition smooths/settles between them (the actual reel
       motion). Fall back to setTimeout(16) only if rAF is genuinely
       unavailable (older WKWebView automation contexts). */
    var raf =
      window.requestAnimationFrame ||
      function (cb) {
        return setTimeout(function () {
          cb(performance.now());
        }, 16);
      };
    var caf = window.cancelAnimationFrame || clearTimeout;
    function frame(now) {
      var t = Math.min(1, (now - start) / duration);
      var val = from + (to - from) * easeOutCubic(t);
      el._odValue = val;
      renderOdometerFrame(el, val);
      if (t < 1) {
        el._odRaf = raf(frame);
      } else {
        el._odValue = to;
        renderOdometerFrame(el, to);
        el._odRaf = null;
        el._odAnimating = false;
      }
    }
    el._odRaf = raf(frame);
    el._odCancelRaf = caf;
  };

  function findQtyInput(stepper) {
    var scope =
      stepper.closest('form') ||
      stepper.closest('[data-aph-atc-wrap]') ||
      stepper.closest('.card-cta-row') ||
      stepper.closest('.featured-cta-row') ||
      stepper.parentElement;
    if (!scope) return null;
    return (
      scope.querySelector('[data-qty-input]') ||
      scope.querySelector('input[name="quantity"]') ||
      null
    );
  }

  function setStepperQty(stepper, n) {
    n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
    var valueEl = stepper.querySelector('[data-qty-value]');
    if (valueEl) valueEl.textContent = String(n);
    var input = findQtyInput(stepper);
    if (input) input.value = String(n);
    stepper.dispatchEvent(new CustomEvent('aph:qty', { detail: { qty: n }, bubbles: true }));
    return n;
  }

  function initQtySteppers(root) {
    (root || document).querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
      var minus = stepper.querySelector('[data-qty-minus]');
      var plus = stepper.querySelector('[data-qty-plus]');
      if (minus) minus.setAttribute('type', 'button');
      if (plus) plus.setAttribute('type', 'button');
      // Sync hidden input to visible value once
      var valueEl = stepper.querySelector('[data-qty-value]');
      var current = parseInt(valueEl && valueEl.textContent, 10) || 1;
      var input = findQtyInput(stepper);
      if (input && !input.value) input.value = String(current);
    });
  }

  // Event delegation: works for PDP, cards, carousels, section reloads
  if (!window.__aphQtyDelegate) {
    window.__aphQtyDelegate = true;
    document.addEventListener(
      'click',
      function (e) {
        var plus = e.target.closest('[data-qty-plus]');
        var minus = e.target.closest('[data-qty-minus]');
        if (!plus && !minus) return;
        var stepper = (plus || minus).closest('[data-qty-stepper]');
        if (!stepper) return;
        e.preventDefault();
        e.stopPropagation();
        var valueEl = stepper.querySelector('[data-qty-value]');
        var cur = parseInt(valueEl && valueEl.textContent, 10) || 1;
        setStepperQty(stepper, plus ? cur + 1 : cur - 1);
      },
      true
    );
  }

  function initBulkTiers(root) {
    var scope = root || document;
    if (document.documentElement.getAttribute('data-aph-hide-qty') === 'true') {
      scope.querySelectorAll('[data-bulk-tiers], .bulk-tiers').forEach(function (el) {
        el.setAttribute('hidden', '');
        el.style.display = 'none';
      });
      return;
    }

    /* Bottle stack + per-tier prices (SSR preferred; JS fills gaps if liquid missed them).
       aph-design.js is not loaded on storefront - keep this self-contained. */
    function formatTierGbp(n) {
      return window.APH && window.APH.formatPrice
        ? window.APH.formatPrice(n)
        : '£' + Number(n).toFixed(2);
    }
    function tierDisc(tier) {
      var dp = tier.getAttribute('data-disc-pct');
      if (dp != null && dp !== '') {
        var n = parseFloat(dp);
        if (!isNaN(n)) return n / 100;
      }
      var saveEl = tier.querySelector('.tier-save');
      if (saveEl) {
        var dm = saveEl.textContent.match(/(\d+)\s*%/);
        if (dm) return parseInt(dm[1], 10) / 100;
      }
      return 0;
    }
    function paintTierSaveMoney(tier, saveAmt, disc) {
      var saveEl = tier.querySelector('.tier-save');
      if (!saveEl) return;
      if (!(disc > 0) || !(saveAmt > 0.004)) {
        saveEl.hidden = true;
        return;
      }
      saveEl.hidden = false;
      var moneyEl = saveEl.querySelector('.tier-save-money');
      if (!moneyEl) {
        saveEl.textContent = 'Save ';
        moneyEl = document.createElement('span');
        moneyEl.className = 'cur-price tier-save-money';
        saveEl.appendChild(moneyEl);
      }
      moneyEl.setAttribute('data-gbp', saveAmt.toFixed(2));
      moneyEl.textContent = formatTierGbp(saveAmt);
    }
    function paintTierCardPrices(wrap) {
      var section =
        wrap.closest('.shopify-section, [data-aph-pdp], [data-aph-product], .aph-main-product, main') ||
        document;
      var priceEl = section.querySelector(
        '.price-row .price .cur-price[data-gbp], .price-row .cur-price[data-gbp], .featured-copy .cur-price[data-gbp]'
      );
      if (!priceEl) return;
      if (!priceEl.getAttribute('data-base-gbp')) {
        priceEl.setAttribute('data-base-gbp', priceEl.getAttribute('data-gbp'));
      }
      var base = parseFloat(priceEl.getAttribute('data-base-gbp')) || 0;
      wrap.querySelectorAll('[data-bulk-tier], .bulk-tier').forEach(function (tier) {
        var q = parseInt(tier.getAttribute('data-qty'), 10) || 1;
        var saveEl = tier.querySelector('.tier-save');
        var disc = tierDisc(tier);
        var unit = Math.round(base * (1 - disc) * 100) / 100;
        var line = Math.round(unit * q * 100) / 100;
        var full = Math.round(base * q * 100) / 100;
        var supplyEl = tier.querySelector('.tier-supply');
        if (supplyEl) supplyEl.remove();
        var qtyEl = tier.querySelector('.tier-qty');
        var priceSpan = tier.querySelector('.tier-price');
        if (!priceSpan) {
          priceSpan = document.createElement('span');
          priceSpan.className = 'tier-price';
          if (qtyEl) qtyEl.insertAdjacentElement('afterend', priceSpan);
          else tier.appendChild(priceSpan);
        }
        priceSpan.textContent = formatTierGbp(line);
        var compareSpan = tier.querySelector('.tier-compare');
        if (disc > 0 && q > 1 && full > line + 0.009) {
          if (!compareSpan) {
            compareSpan = document.createElement('span');
            compareSpan.className = 'tier-compare';
            priceSpan.insertAdjacentElement('afterend', compareSpan);
          }
          compareSpan.hidden = false;
          compareSpan.textContent = formatTierGbp(full);
        } else if (compareSpan) {
          compareSpan.hidden = true;
          compareSpan.textContent = '';
        }
        if (saveEl) paintTierSaveMoney(tier, Math.round((full - line) * 100) / 100, disc);
      });
    }
    function ensureTierBottles(wrap) {
      var bottleEl = document.querySelector('[data-bulk-bottle]');
      var bottleSrc = (bottleEl && bottleEl.getAttribute('src')) || '';
      if (!bottleSrc) return;
      wrap.querySelectorAll('[data-bulk-tier], .bulk-tier').forEach(function (tier) {
        if (tier.querySelector('.tier-bottles')) return;
        var qty = parseInt(tier.getAttribute('data-qty'), 10);
        if (!qty) {
          var qtyEl = tier.querySelector('.tier-qty');
          var m = qtyEl && qtyEl.textContent.match(/(\d+)/);
          qty = m ? parseInt(m[1], 10) : 1;
        }
        var wrapEl = document.createElement('span');
        wrapEl.className = 'tier-bottles';
        wrapEl.setAttribute('aria-hidden', 'true');
        for (var i = 0; i < qty; i++) {
          var img = document.createElement('img');
          img.src = bottleSrc;
          img.alt = '';
          img.width = 34;
          img.height = 58;
          wrapEl.appendChild(img);
        }
        tier.insertBefore(wrapEl, tier.firstChild);
        var check = tier.querySelector('.tier-check');
        if (check) check.style.display = 'none';
      });
    }

    /**
     * Update qty + price for a bulk tier.
     * @param {boolean} animate - true = demos odometer reel to LINE total
     */
    function applyTierPrice(wrap, tier, animate) {
      var q = parseInt(tier.getAttribute('data-qty'), 10) || 1;
      var section =
        wrap.closest('.shopify-section, [data-aph-pdp], [data-aph-product], .aph-main-product, main') ||
        document;
      var form =
        wrap.closest('form') ||
        section.querySelector('form.aph-product-form, form[data-type="add-to-cart-form"]') ||
        document.querySelector('form.aph-product-form, form[data-type="add-to-cart-form"]');
      var qtyInput = form && form.querySelector('input[name="quantity"], [data-qty-input]');
      if (qtyInput) qtyInput.value = String(q);
      var stepper =
        (form && form.querySelector('[data-qty-stepper]')) || section.querySelector('[data-qty-stepper]');
      if (stepper) setStepperQty(stepper, q);
      else {
        var stepperVal =
          (form && form.querySelector('[data-qty-value]')) || section.querySelector('[data-qty-value]');
        if (stepperVal) stepperVal.textContent = String(q);
      }

      /* Line total from base unit + tier save % × qty (demos selectTier) */
      var priceEl = section.querySelector(
        '.price-row .price .cur-price[data-gbp], .price-row .cur-price[data-gbp], .featured-copy .cur-price[data-gbp]'
      );
      if (!priceEl) return;
      if (!priceEl.getAttribute('data-base-gbp')) {
        priceEl.setAttribute('data-base-gbp', priceEl.getAttribute('data-gbp'));
      }
      var base = parseFloat(priceEl.getAttribute('data-base-gbp')) || 0;
      var saveEl = tier.querySelector('.tier-save');
      var disc = tierDisc(tier);
      var unit = Math.round(base * (1 - disc) * 100) / 100;
      var line = Math.round(unit * q * 100) / 100;

      /* Unit for cart math; display animates to LINE total (demos selectTier) */
      priceEl.setAttribute('data-unit-gbp', unit.toFixed(2));
      priceEl.setAttribute('data-line-gbp', line.toFixed(2));
      /* data-gbp stays UNIT so ATC / currency don't treat line as unit */
      priceEl.setAttribute('data-gbp', unit.toFixed(2));

      if (typeof window.APH.animatePrice === 'function') {
        window.APH.animatePrice(priceEl, line, { duration: animate ? 480 : 0 });
      } else {
        priceEl.textContent =
          window.APH.formatPrice ? window.APH.formatPrice(line) : '£' + line.toFixed(2);
      }

      var compareEl = section.querySelector(
        '.price-row .price-compare .cur-price[data-gbp], .price-row .price-compare .cur-price'
      );
      if (compareEl) {
        if (!compareEl.getAttribute('data-base-gbp')) {
          compareEl.setAttribute(
            'data-base-gbp',
            compareEl.getAttribute('data-gbp') || String(base)
          );
        }
        var cBase =
          parseFloat(compareEl.getAttribute('data-base-gbp')) ||
          parseFloat(compareEl.getAttribute('data-gbp')) ||
          base;
        var full = Math.round(cBase * q * 100) / 100;
        compareEl.setAttribute('data-gbp', full.toFixed(2));
        compareEl.removeAttribute('data-odometer');
        compareEl.classList.remove('price-odometer');
        compareEl.textContent =
          window.APH.formatPrice ? window.APH.formatPrice(full) : '£' + full.toFixed(2);
      }

      wrap.dispatchEvent(
        new CustomEvent('bulk-tier-change', {
          bubbles: true,
          detail: { qty: q, unitGbp: unit, lineGbp: line, discount: disc },
        })
      );
    }

    scope.querySelectorAll('[data-bulk-tiers], .bulk-tiers').forEach(function (wrap) {
      ensureTierBottles(wrap);
      paintTierCardPrices(wrap);
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      wrap.querySelectorAll('[data-bulk-tier], .bulk-tier').forEach(function (tier) {
        tier.addEventListener('click', function () {
          var tiers = wrap.querySelectorAll('[data-bulk-tier], .bulk-tier');
          var idx = Array.prototype.indexOf.call(tiers, tier);
          tiers.forEach(function (t, i) {
            t.classList.toggle('active', i === idx);
            t.classList.toggle('reached', i <= idx);
          });
          applyTierPrice(wrap, tier, true);
        });
      });
      /* Seed odometer on active tier without spinning on load */
      var active = wrap.querySelector('.bulk-tier.active, [data-bulk-tier].active') ||
        wrap.querySelector('[data-bulk-tier], .bulk-tier');
      if (active) applyTierPrice(wrap, active, false);
    });
  }

  function initAccordions(root) {
    (root || document).querySelectorAll('.pdp-accordion-trigger').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.pdp-accordion-item');
        if (!item) return;
        var open = item.classList.contains('open');
        var acc = item.parentElement;
        if (acc) {
          acc.querySelectorAll('.pdp-accordion-item.open').forEach(function (i) {
            i.classList.remove('open');
          });
        }
        if (!open) item.classList.add('open');
      });
    });
  }

  function initPromoSwiper(root) {
    if (typeof Swiper === 'undefined') return;
    var scope = root || document;
    scope.querySelectorAll('[data-promo-swiper]').forEach(function (el) {
      if (el.dataset.swiperInit) return;
      el.dataset.swiperInit = '1';
      var host = el.closest('[data-promo-swiper-host]') || el.parentElement;
      var bar = el.closest('[data-promo-bar]') || el.closest('.promo-bar');
      if (bar) bar.classList.add('has-promo-swiper');
      var delay = parseInt(el.getAttribute('data-delay'), 10) || 4200;
      var slideCount = el.querySelectorAll('.swiper-slide').length;
      if (slideCount < 2) return;
      var swiper = new Swiper(el, {
        slidesPerView: 1,
        loop: true,
        speed: 380,
        grabCursor: true,
        simulateTouch: true,
        allowTouchMove: true,
        resistanceRatio: 0.65,
        autoplay: {
          delay: delay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
      });
      var prev = host && host.querySelector('[data-promo-prev]');
      var next = host && host.querySelector('[data-promo-next]');
      if (prev) {
        prev.addEventListener('click', function (e) {
          e.preventDefault();
          swiper.slidePrev();
        });
      }
      if (next) {
        next.addEventListener('click', function (e) {
          e.preventDefault();
          swiper.slideNext();
        });
      }
      el.addEventListener(
        'touchstart',
        function () {
          if (swiper.autoplay) swiper.autoplay.stop();
        },
        { passive: true }
      );
      el.addEventListener(
        'touchend',
        function () {
          if (swiper.autoplay) swiper.autoplay.start();
        },
        { passive: true }
      );
    });
  }

  function initBlogSwiper(attempt) {
    attempt = attempt || 0;
    if (typeof Swiper === 'undefined') {
      if (attempt < 40) setTimeout(function () { initBlogSwiper(attempt + 1); }, 50);
      return;
    }
    document.querySelectorAll('[data-blog-swiper]').forEach(function (el) {
      if (el.dataset.swiperInit) return;
      el.dataset.swiperInit = '1';
      // Demos card style + always-on swiper so desktop shows ~4 and can swipe for more
      new Swiper(el, {
        loop: false,
        autoHeight: true,
        slidesPerView: 1.2,
        spaceBetween: 14,
        grabCursor: true,
        breakpoints: {
          640: { slidesPerView: 1.65, spaceBetween: 16 },
          760: { slidesPerView: 2.15, spaceBetween: 16 },
          1000: { slidesPerView: 3.2, spaceBetween: 18 },
          1200: { slidesPerView: 4, spaceBetween: 18 },
        },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });
  }

  /** Homepage "What customers say" - was only in aph-design.js (not loaded). */
  function initReviewsSwiper(attempt) {
    attempt = attempt || 0;
    if (typeof Swiper === 'undefined') {
      if (attempt < 40) setTimeout(function () { initReviewsSwiper(attempt + 1); }, 50);
      return;
    }
    document.querySelectorAll('[data-reviews-swiper]').forEach(function (el) {
      if (el.dataset.swiperInit) return;
      el.dataset.swiperInit = '1';
      var slides = el.querySelectorAll('.swiper-slide').length;
      new Swiper(el, {
        loop: slides > 3,
        autoHeight: false,
        autoplay: slides > 1 ? { delay: 6000, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
        speed: 500,
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints: {
          640: { slidesPerView: 2, spaceBetween: 16 },
          900: { slidesPerView: 3, spaceBetween: 18 },
          1400: { slidesPerView: 4, spaceBetween: 18 },
        },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });
  }

  function initHeroSwiper() {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('[data-hero-swiper]').forEach(function (el) {
      if (el.dataset.swiperInit) return;
      el.dataset.swiperInit = '1';
      var delay = parseInt(el.getAttribute('data-delay'), 10) || 5500;
      var autoplayOn = el.getAttribute('data-autoplay') !== 'false';
      var slideCount = el.querySelectorAll('.swiper-slide').length;
      new Swiper(el, {
        loop: slideCount > 1,
        autoHeight: true,
        autoplay: autoplayOn && slideCount > 1
          ? { delay: delay, disableOnInteraction: false }
          : false,
        pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
        navigation: {
          nextEl: el.querySelector('[data-hero-next]'),
          prevEl: el.querySelector('[data-hero-prev]'),
        },
        speed: 600,
        grabCursor: true,
        simulateTouch: true,
        allowTouchMove: true,
        threshold: 8,
        preventClicks: false,
        preventClicksPropagation: false,
        touchStartPreventDefault: false,
        observer: true,
        observeParents: true,
      });
    });
    document.querySelectorAll('[data-chips-swiper]').forEach(function (el) {
      if (el.dataset.swiperInit) return;
      el.dataset.swiperInit = '1';
      new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        freeMode: true,
      });
    });
    window.APH_BS_SLIDES = 5; // force 5-up bestsellers
    document.querySelectorAll('[data-af-swiper]').forEach(function (el) {
      if (el.dataset.swiperInit) return;
      el.dataset.swiperInit = '1';
      new Swiper(el, {
        grabCursor: true,
        slidesPerView: 1.08,
        spaceBetween: 12,
        pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
        breakpoints: {
          700: { slidesPerView: 2.15, spaceBetween: 14 },
          990: { slidesPerView: 4, spaceBetween: 16 }
        }
      });
    });
    document.querySelectorAll('[data-product-carousel]').forEach(function (el) {
      if (el.dataset.swiperInit) return;
      el.dataset.swiperInit = '1';
      var wrap = el.closest('.aph-carousel-wrap') || el.parentElement;
      new Swiper(el, {
        loop: el.dataset.carouselLoop === 'true',
        grabCursor: true,
        slidesPerView: 1.25,
        spaceBetween: 14,
        breakpoints: {
          600: { slidesPerView: 2.2, spaceBetween: 16 },
          800: { slidesPerView: 3.2, spaceBetween: 16 },
          990: { slidesPerView: 5, spaceBetween: 14 }
        },
        navigation: {
          nextEl: wrap && wrap.querySelector('[data-carousel-next]'),
          prevEl: wrap && wrap.querySelector('[data-carousel-prev]')
        },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true
        }
      });
    });
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      try { window.jdgm.customizeBadges(); } catch (e) {}
    }
  }

  function initAtcSpinner() {
    if (window.__aphAtcSpinnerBound) return;
    window.__aphAtcSpinnerBound = true;
    function setBusy(btn, on) {
      if (!btn) return;
      btn.classList.toggle('loading', !!on);
      if (on) btn.setAttribute('aria-busy', 'true');
      else btn.removeAttribute('aria-busy');
      var spin = btn.querySelector('.loading__spinner');
      if (spin) spin.classList.toggle('hidden', !on);
    }
    function arm(btn) {
      if (!btn || btn.disabled) return;
      setBusy(btn, true);
      var html = document.documentElement;
      var done = false;
      function off() {
        if (done) return;
        done = true;
        setBusy(btn, false);
        if (mo) mo.disconnect();
        clearTimeout(t);
      }
      var t = setTimeout(off, 8000);
      var mo = new MutationObserver(function () {
        if (html.classList.contains('cart-drawer-open')) off();
      });
      mo.observe(html, { attributes: true, attributeFilter: ['class'] });
      if (html.classList.contains('cart-drawer-open')) off();
    }
    function isAtcBtn(el) {
      if (!el || el.disabled) return false;
      return el.matches('button[name="add"], [data-aph-atc], .aph-cart-suggest-add');
    }
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('button[name="add"], [data-aph-atc], .aph-cart-suggest-add') : null;
        if (!isAtcBtn(btn)) return;
        arm(btn);
      },
      true
    );
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target && e.target.closest ? e.target.closest('form') : null;
        if (!form) return;
        if (!form.matches('.aph-card-form, .aph-cart-suggest-form, .aph-product-form, form[data-type="add-to-cart-form"]')) return;
        var btn = form.querySelector('button[name="add"], [data-aph-atc], .aph-cart-suggest-add');
        if (isAtcBtn(btn)) arm(btn);
      },
      true
    );
  }

  function initCardForms() {
    /* .aph-card-form = grid/carousel quick-add. Also cover the featured
       spotlight buy-box form (mens Man Stack etc) and the cart-drawer
       upsell Add form - both were native submits dumping users on /cart
       instead of opening the drawer (Harry 2026-09-15). The Dawn-handled
       main PDP form (data-type=add-to-cart-form) is explicitly excluded.
       Delegated (not per-form): the drawer re-renders its subtree on every
       cart AJAX update, which destroyed per-form bindings on the upsell
       form - a document-level listener survives the re-render. */
    if (window.__aphCardFormsDelegated) return;
    window.__aphCardFormsDelegated = true;
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('.aph-card-form, .aph-cart-suggest-form, .featured-product form:not([data-type])') : null;
      if (!form) return;
      {
        e.preventDefault();
        e.stopPropagation();
        var fd = new FormData(form);
        var row = form.closest('.card-cta-row');
        var qtyInput = form.querySelector('[data-qty-input], input[name="quantity"]');
        var qtyLabel = form.querySelector('[data-qty-value]') || (row && row.querySelector('[data-qty-value]'));
        var qLabel = qtyLabel && qtyLabel.textContent ? parseInt(qtyLabel.textContent, 10) : NaN;
        var qInput = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : NaN;
        var q = !isNaN(qLabel) ? qLabel : !isNaN(qInput) ? qInput : 1;
        q = Math.max(1, Math.min(99, q));
        if (qtyInput) qtyInput.value = String(q);
        fd.set('quantity', String(q));
        var variantId = form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value;
        if (window.APH && typeof window.APH.addToCart === 'function') {
          window.APH
            .addToCart(variantId ? { id: variantId, quantity: q } : fd)
            .catch(function (err) {
              console.warn('[aph] addToCart failed', err);
              if (window.APH && window.APH.unlockPage) window.APH.unlockPage();
              var msg = (err && (err.description || err.message)) || 'Could not add to cart.';
              window.alert(msg);
            });
          return;
        }
        fd.set('sections', 'cart-drawer,cart-icon-bubble');
        fd.set('sections_url', window.location.pathname || '/');
        fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: fd,
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (state) {
            if (window.APH && window.APH.openCartDrawer) {
              window.APH.openCartDrawer(state);
              return;
            }
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.renderContents === 'function') {
              drawer.renderContents(state);
            } else if (drawer && typeof drawer.open === 'function') {
              drawer.open();
            } else {
              var d = document.querySelector('cart-drawer');
              if (d && typeof d.open === 'function') d.open();
            }
          })
          .catch(function () {
            if (window.APH && window.APH.unlockPage) window.APH.unlockPage();
          });
      }
    });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(amount) {
    var n = parseFloat(amount);
    if (isNaN(n)) return '';
    if (window.APH && typeof window.APH.formatPrice === 'function') {
      return window.APH.formatPrice(n);
    }
    return '£' + n.toFixed(2);
  }

  function initSearchDrawer() {
    var drawer = document.querySelector('[data-search-drawer]');
    var overlay = document.querySelector('[data-search-overlay]');
    if (!drawer) return;

    function openSearch() {
      drawer = document.querySelector('[data-search-drawer]') || drawer;
      overlay = document.querySelector('[data-search-overlay]') || overlay;
      if (!drawer) return;
      drawer.hidden = false;
      drawer.removeAttribute('hidden');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) {
        overlay.hidden = false;
        overlay.removeAttribute('hidden');
      }
      document.documentElement.classList.add('search-drawer-open');
      document.body.style.overflow = 'hidden';
      // Force reflow so closed transform paints, then open → slide
      void drawer.offsetWidth;
      requestAnimationFrame(function () {
        drawer.classList.add('open');
        if (overlay) overlay.classList.add('open');
      });
      var input = drawer.querySelector('[data-search-input]');
      if (input) {
        setTimeout(function () {
          try {
            input.focus({ preventScroll: true });
          } catch (err) {
            input.focus();
          }
        }, 100);
      }
    }

    function closeSearch() {
      drawer = document.querySelector('[data-search-drawer]') || drawer;
      overlay = document.querySelector('[data-search-overlay]') || overlay;
      if (!drawer) return;
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('open');
      document.documentElement.classList.remove('search-drawer-open');
      document.body.style.overflow = '';
      setTimeout(function () {
        if (!drawer.classList.contains('open')) {
          drawer.hidden = true;
          drawer.setAttribute('hidden', '');
          if (overlay) {
            overlay.hidden = true;
            overlay.setAttribute('hidden', '');
          }
        }
      }, 420);
    }

    // Document-level delegation so header re-renders still open search
    if (!window.__aphSearchDrawerBound) {
      window.__aphSearchDrawerBound = true;
      document.addEventListener(
        'click',
        function (e) {
          var openBtn = e.target.closest && e.target.closest('[data-search-toggle], [data-search-drawer-open]');
          if (openBtn) {
            e.preventDefault();
            e.stopPropagation();
            openSearch();
            return;
          }
          var closeBtn = e.target.closest && e.target.closest('[data-search-drawer-close]');
          if (closeBtn) {
            e.preventDefault();
            closeSearch();
            return;
          }
          // Click-away: overlay scrim OR any click outside open drawer panel
          var openDrawer = document.querySelector('[data-search-drawer].open');
          if (!openDrawer) return;
          if (e.target.closest && e.target.closest('[data-search-overlay]')) {
            closeSearch();
            return;
          }
          if (openDrawer.contains(e.target)) return;
          closeSearch();
        },
        true
      );
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          var d = document.querySelector('[data-search-drawer].open');
          if (d) closeSearch();
        }
      });
    }

    // Expose for section:load / external open
    window.APH = window.APH || {};
    window.APH.openSearch = openSearch;
    window.APH.closeSearch = closeSearch;

    /* Bind every search instance on the page — the drawer's, and the
       homepage inline .search-bar (aph-search-bar.liquid) if present.
       setupSearchInstance resolves its own root via closest(), so this is
       safe to call broadly; it no-ops on already-bound inputs. */
    document.querySelectorAll('[data-search-input]').forEach(setupSearchInstance);
  }

  function setupSearchInstance(searchInput) {
    if (!searchInput || searchInput.__aphSearchBound) return;
    searchInput.__aphSearchBound = true;
    var root = searchInput.closest('.search-drawer') || searchInput.closest('.search-bar') || document;
    var searchResults = root.querySelector('[data-search-results]');
    if (!searchResults) return;
    var searchPopular = root.querySelector('[data-search-popular]');
    var searchMatches = root.querySelector('[data-search-matches]');
    var searchNoResults = root.querySelector('[data-search-no-results]');
    var listProducts = root.querySelector('[data-search-list-products]');
    var listBlog = root.querySelector('[data-search-list-blog]');
    var listPages = root.querySelector('[data-search-list-pages]');
    var sectionProducts = root.querySelector('[data-search-section-products]');
    var sectionBlog = root.querySelector('[data-search-section-blog]');
    var sectionPages = root.querySelector('[data-search-section-pages]');
    var viewAll = root.querySelector('[data-search-view-all]');
    var viewAllLink = root.querySelector('[data-search-view-all-link]');
    var clearBtn = root.querySelector('[data-search-clear]');
    var debounceTimer = null;
    var suggestUrl =
      (window.routes && window.routes.predictive_search_url) || '/search/suggest';

    function openResults() {
      searchResults.hidden = false;
      searchResults.removeAttribute('hidden');
    }

    function hideResults() {
      searchResults.hidden = true;
      searchResults.setAttribute('hidden', '');
    }

    function updateClearVisibility() {
      if (!clearBtn) return;
      clearBtn.hidden = !searchInput.value.trim();
    }

    if (clearBtn) {
      /* Harry 2026-08-05 round 2: the clear-X was invisible — white stroke
         on a white button, so it was there but unreadable. A generic
         `.search-form button svg{stroke:#fff!important}` rule (meant for
         the black submit button) was beating a same-!important, seemingly
         more-specific `.search-form button.search-form-clear svg` override
         (same unresolved specificity-tie class of bug hit repeatedly in
         this codebase). Set it as an inline style instead — always wins
         over any external stylesheet rule regardless of specificity. */
      var clearSvg = clearBtn.querySelector('svg');
      if (clearSvg) clearSvg.style.setProperty('stroke', '#999', 'important');

      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        searchInput.value = '';
        updateClearVisibility();
        showEmptyState();
        searchInput.focus();
      });
    }

    /* Click outside this search instance (form + results panel) closes the
       results dropdown — separate from the search DRAWER's own open/close,
       which already handles the drawer case; this covers the plain inline
       .search-bar that has no drawer wrapper to close. */
    document.addEventListener(
      'click',
      function (e) {
        if (searchResults.hidden) return;
        if (root.contains(e.target)) return;
        hideResults();
      },
      true
    );
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !searchResults.hidden) {
        hideResults();
        searchInput.blur();
      }
    });

    function showEmptyState() {
      if (searchInput.closest('.aph-search-bar-inline')) {
        hideResults();
        return;
      }
      if (searchPopular) searchPopular.hidden = false;
      if (searchMatches) searchMatches.hidden = true;
      if (searchNoResults) searchNoResults.hidden = true;
      openResults();
    }

    function productRow(p) {
      var img =
        p.image ||
        (p.featured_image && (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.url)) ||
        (p.images && p.images[0]) ||
        '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var thumb = img
        ? '<img src="' + escapeHtml(img) + '" alt="" width="56" height="56" loading="lazy">'
        : '<div class="ph-block"></div>';
      var rawPrice = p.price != null ? p.price : p.price_min != null ? p.price_min : null;
      // Shopify suggest may return pounds string "49.99" or cents number
      var price = '';
      if (rawPrice != null && rawPrice !== '') {
        var n = parseFloat(String(rawPrice).replace(/[^\d.]/g, ''));
        if (!isNaN(n)) {
          if (n > 500) n = n / 100; // cents
          price = formatMoney(n);
        }
      }
      var tag = p.product_type || p.vendor || p.type || '';
      var url = p.url || (p.handle ? '/products/' + p.handle : '#');
      return (
        '<a href="' +
        escapeHtml(url) +
        '" class="search-result-item">' +
        '<span class="search-result-thumb">' +
        thumb +
        '</span>' +
        '<span class="search-result-info"><strong>' +
        escapeHtml(p.title || p.name || '') +
        '</strong><span>' +
        escapeHtml(tag) +
        '</span></span>' +
        (price ? '<span class="search-result-price">' + escapeHtml(price) + '</span>' : '') +
        '</a>'
      );
    }

    /* Expand short / alias queries so 5-Amino is findable as 1mq, 1-mq, amino, etc. */
    var SEARCH_ALIASES = {
      '1mq': '5-amino-1-mq',
      '1-mq': '5-amino-1-mq',
      '1 mq': '5-amino-1-mq',
      amino: '5-amino',
      '5amino': '5-amino',
      '5 amino': '5-amino',
      mq: '5-amino-1-mq',
      nnmt: '5-amino',
      acetamoren: 'mk-777',
      mk777: 'mk-777',
      'mk 777': 'mk-777',
    };

    function expandQuery(q) {
      var key = String(q || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');
      if (SEARCH_ALIASES[key]) return SEARCH_ALIASES[key];
      // partial: "1mq" inside longer string
      if (/\b1[\s-]?mq\b/i.test(q) || /\b5[\s-]?amino\b/i.test(q)) return '5-amino 1-mq';
      return q;
    }

    function mergeProductLists(a, b) {
      var seen = {};
      var out = [];
      function add(list) {
        (list || []).forEach(function (p) {
          var id = String(p.id || p.handle || p.url || p.title || '');
          if (!id || seen[id]) return;
          seen[id] = true;
          out.push(p);
        });
      }
      add(a);
      add(b);
      return out;
    }

    function articleRow(a) {
      var img = a.image || (a.image && a.image.url) || '';
      var thumb = img
        ? '<img src="' + escapeHtml(typeof img === 'string' ? img : img.url || '') + '" alt="" width="44" height="44" loading="lazy">'
        : '<div class="ph-block"></div>';
      return (
        '<a href="' +
        escapeHtml(a.url || '#') +
        '" class="search-result-item">' +
        '<span class="search-result-thumb">' +
        thumb +
        '</span>' +
        '<span class="search-result-info"><strong>' +
        escapeHtml(a.title || '') +
        '</strong><span>' +
        escapeHtml((a.summary || a.body || '').replace(/<[^>]+>/g, '').slice(0, 80)) +
        '</span></span>' +
        '</a>'
      );
    }

    function pageRow(p) {
      var fileIcon =
        '<svg viewBox="0 0 256 256" width="18" height="18"><path d="M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="152 32 152 88 208 88" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>';
      return (
        '<a href="' +
        escapeHtml(p.url || '#') +
        '" class="search-result-item">' +
        '<span class="search-result-thumb">' +
        fileIcon +
        '</span>' +
        '<span class="search-result-info"><strong>' +
        escapeHtml(p.title || '') +
        '</strong></span>' +
        '</a>'
      );
    }

    function renderFromData(query, data) {
      var results = (data && data.resources && data.resources.results) || {};
      var products = results.products || [];
      var articles = results.articles || [];
      var pages = results.pages || [];
      var total = products.length + articles.length + pages.length;

      if (searchPopular) searchPopular.hidden = true;

      if (total === 0) {
        if (searchMatches) searchMatches.hidden = true;
        if (searchNoResults) searchNoResults.hidden = false;
        openResults();
        return;
      }

      if (searchNoResults) searchNoResults.hidden = true;
      if (searchMatches) searchMatches.hidden = false;

      if (sectionProducts && listProducts) {
        sectionProducts.hidden = products.length === 0;
        listProducts.innerHTML = products.slice(0, 8).map(productRow).join('');
      }
      if (sectionBlog && listBlog) {
        sectionBlog.hidden = articles.length === 0;
        listBlog.innerHTML = articles.slice(0, 3).map(articleRow).join('');
      }
      if (sectionPages && listPages) {
        sectionPages.hidden = pages.length === 0;
        listPages.innerHTML = pages.slice(0, 3).map(pageRow).join('');
      }
      if (viewAll) {
        viewAll.hidden = false;
        var q = query.trim();
        root.querySelectorAll('[data-search-view-all-label]').forEach(function (el) {
          el.textContent = 'View all results for "' + q + '"';
        });
        if (viewAllLink) {
          viewAllLink.href =
            ((window.routes && window.routes.search_url) || '/search') +
            '?q=' +
            encodeURIComponent(q);
        }
      }
      openResults();
    }

    function fetchSuggest(query) {
      var raw = query.trim();
      if (!raw) {
        showEmptyState();
        return;
      }
      var q = expandQuery(raw);
      /* `handle` is not a valid searchable field for this endpoint (fields
         scopes which TEXT fields get matched against, not what's returned)
         — including it made Shopify reject the whole request with a 422,
         which is the real root cause traced above. */
      var fields = 'title,product_type,variants.title,vendor,tag,body';
      /* Harry 2026-08-05: search for a real product ("rad", "rad 140") was
         silently returning "no results" — Shopify's suggest endpoint was
         responding 422 "Invalid option for `fields` parameter". Root cause:
         these static param names have literal, un-encoded [ ] characters
         concatenated straight into the URL string (only the user's own
         query term went through encodeURIComponent). fetch() doesn't
         reject on a 4xx status, so r.json() happily parsed the error body
         as "valid" data with no products — total looked like a genuine
         zero-result search every single time, for every query, silently.
         Encode every param name/value through URLSearchParams instead. */
      function buildUrl(term) {
        var params = new URLSearchParams();
        params.set('q', term);
        params.set('resources[type]', 'product,page,article');
        params.set('resources[limit]', '10');
        params.set('resources[limit_scope]', 'each');
        params.set('resources[options][unavailable_products]', 'last');
        params.set('resources[options][fields]', fields);
        return suggestUrl + '.json?' + params.toString();
      }

      var primary = fetch(buildUrl(q), { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json();
      });

      // Second pass: if alias expanded, also try raw query; if still empty, try product handle
      var secondary =
        q !== raw
          ? fetch(buildUrl(raw), { headers: { Accept: 'application/json' } }).then(function (r) {
              return r.json();
            })
          : Promise.resolve(null);

      Promise.all([primary, secondary])
        .then(function (pair) {
          var data = pair[0] || { resources: { results: {} } };
          var extra = pair[1];
          if (extra && extra.resources && extra.resources.results) {
            var a = (data.resources && data.resources.results) || {};
            var b = extra.resources.results || {};
            data.resources = data.resources || {};
            data.resources.results = {
              products: mergeProductLists(a.products, b.products),
              articles: mergeProductLists(a.articles, b.articles),
              pages: mergeProductLists(a.pages, b.pages),
            };
          }
          var products =
            (data.resources && data.resources.results && data.resources.results.products) || [];
          /* Discontinued (Harry 2026-09-22): tagged products keep live URLs
             (discontinued PDP) but never surface in the search drawer. */
          products = products.filter(function (p) {
            return (p.tags || []).indexOf('discontinued') === -1;
          });
          if (data.resources && data.resources.results) {
            data.resources.results.products = products;
          }
          // Fallback: direct product fetch for known handles when suggest misses
          if (products.length === 0 && /5-amino|1-?mq|amino/i.test(raw + ' ' + q)) {
            return fetch('/products/5-amino-1-mq.js', { headers: { Accept: 'application/json' } })
              .then(function (r) {
                return r.ok ? r.json() : null;
              })
              .then(function (prod) {
                if (prod && prod.title) {
                  data.resources = data.resources || { results: {} };
                  data.resources.results = data.resources.results || {};
                  data.resources.results.products = [
                    {
                      title: prod.title,
                      handle: prod.handle,
                      url: '/products/' + prod.handle,
                      price: prod.price / 100,
                      image: prod.featured_image,
                      product_type: prod.type || prod.product_type || '',
                      id: prod.id,
                    },
                  ];
                }
                renderFromData(raw, data);
              })
              .catch(function () {
                renderFromData(raw, data);
              });
          }
          renderFromData(raw, data);
        })
        .catch(function () {
          if (searchPopular) searchPopular.hidden = true;
          if (searchMatches) searchMatches.hidden = true;
          if (searchNoResults) searchNoResults.hidden = false;
          openResults();
        });
    }

    function onQueryChange() {
      clearTimeout(debounceTimer);
      updateClearVisibility();
      var q = searchInput.value;
      if (!q.trim()) {
        showEmptyState();
        return;
      }
      debounceTimer = setTimeout(function () {
        fetchSuggest(q);
      }, 180);
    }

    searchInput.addEventListener('input', onQueryChange);
    searchInput.addEventListener('focus', function () {
      updateClearVisibility();
      if (!searchInput.value.trim()) showEmptyState();
      else fetchSuggest(searchInput.value);
    });
    updateClearVisibility();

    root.addEventListener('click', function (e) {
      var tag = e.target.closest ? e.target.closest('[data-search-tag]') : null;
      if (tag && root.contains(tag)) {
        e.preventDefault();
        searchInput.value = tag.textContent.trim();
        fetchSuggest(searchInput.value);
        searchInput.focus();
      }
    });

    var form = searchInput.closest('form');
    if (form) {
      form.addEventListener('submit', function () {
        /* allow native search page submit */
      });
    }
  }

  /* Promo bar discount codes - click to copy */
  function initPromoCodeCopy(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-copy-code]').forEach(function (btn) {
      if (btn.dataset.copyBound) return;
      btn.dataset.copyBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var code = btn.getAttribute('data-copy-code') || '';
        if (!code) return;
        var label = btn.querySelector('[data-copy-label]') || btn;
        var original = label.textContent;

        function flashCopied() {
          btn.classList.add('is-copied');
          label.textContent = 'Copied!';
          btn.setAttribute('aria-label', 'Code ' + code + ' copied');
          setTimeout(function () {
            btn.classList.remove('is-copied');
            label.textContent = original;
            btn.setAttribute('aria-label', 'Copy code ' + code);
          }, 1600);
        }

        function fallbackCopy() {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.cssText = 'position:fixed;left:-9999px;top:0';
          document.body.appendChild(ta);
          ta.select();
          try {
            document.execCommand('copy');
            flashCopied();
          } catch (err) {
            /* ignore */
          }
          document.body.removeChild(ta);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(flashCopied).catch(fallbackCopy);
        } else {
          fallbackCopy();
        }
      });
    });
  }

  /* Parkezi-style page scroll progress under the nav */
  function initScrollProgress() {
    var bar = document.querySelector('[data-scroll-progress]') || document.querySelector('.progress-bar');
    if (!bar || bar.dataset.bound) return;
    bar.dataset.bound = '1';
    function updateProgress() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var pct = docHeight > 0 ? Math.min(100, (scrollTop / docHeight) * 100) : 0;
      bar.style.width = pct + '%';
    }
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
    updateProgress();
  }

  /* External account dropdown (checkout.aphscience.com) — not Shopify customer accounts */
  function initAccountMenu() {
    if (window.__aphAccountMenu) return;
    window.__aphAccountMenu = true;

    function closeAll(except) {
      document.querySelectorAll('[data-account-menu].is-open').forEach(function (m) {
        if (except && m === except) return;
        m.classList.remove('is-open');
        var btn = m.querySelector('[data-account-toggle]');
        var dd = m.querySelector('[data-account-dropdown]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (dd) dd.hidden = true;
      });
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-account-toggle]');
      var menu = e.target.closest('[data-account-menu]');
      if (toggle && menu) {
        e.preventDefault();
        e.stopPropagation();
        var open = !menu.classList.contains('is-open');
        closeAll(open ? menu : null);
        var dd = menu.querySelector('[data-account-dropdown]');
        if (open) {
          menu.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          if (dd) dd.hidden = false;
        } else {
          menu.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          if (dd) dd.hidden = true;
        }
        return;
      }
      if (!menu) closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* Delegated on document, bound once (Harry 2026-08-08: "YMAL accordion
     must toggle open/close" - direct per-button binding lost its listener
     the moment the drawer's HTML got replaced by ANY cart mutation - add,
     remove, qty change all swap #CartDrawer's innerHTML wholesale (Dawn's
     own cart.js, and this theme's refreshDrawerSection for the gift sync),
     none of which re-fire shopify:section:load, so a freshly-inserted
     button was never rebound. Delegation survives replacement for free -
     same fix already used for the qty-stepper buttons elsewhere. */
  if (!window.__aphCartSuggestDelegate) {
    window.__aphCartSuggestDelegate = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-aph-cart-suggest-toggle]');
      if (!btn) return;
      var wrap = btn.closest('[data-aph-cart-suggest]');
      if (!wrap) return;
      var open = wrap.classList.toggle('is-collapsed');
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  /** PDP “Is this for me?” quiz (demos parity) */
  function initPdpQuiz(root) {
    (root || document).querySelectorAll('[data-pdp-quiz]').forEach(function (quizEl) {
      if (quizEl.dataset.bound) return;
      quizEl.dataset.bound = '1';
      var group = quizEl.getAttribute('data-quiz-group') || 'supplement';
      var pctNeeded = quizEl.getAttribute('data-quiz-pct') === 'true';
      var nameEl = document.querySelector('.featured-copy h1, [data-aph-pdp] h1');
      var productName = nameEl ? nameEl.textContent.trim() : 'this product';
      var trigger = quizEl.querySelector('[data-pdp-quiz-trigger]');
      var body = quizEl.querySelector('.pdp-quiz-body');
      var nattyStep = quizEl.querySelector('[data-quiz-step="natty"]');
      var goalStep = quizEl.querySelector('[data-quiz-step="goal"]');
      var resultEl = quizEl.querySelector('[data-quiz-result]');
      if (!trigger || !body || !goalStep || !resultEl) return;

      if (group !== 'hormonal' && nattyStep) {
        nattyStep.hidden = true;
        goalStep.hidden = false;
      }

      trigger.addEventListener('click', function () {
        var isOpen = quizEl.classList.toggle('open');
        body.hidden = !isOpen;
      });

      function showResult(html) {
        if (nattyStep) nattyStep.hidden = true;
        goalStep.hidden = true;
        resultEl.innerHTML =
          html +
          '<br><button type="button" class="pdp-quiz-restart" data-quiz-restart>Start again</button>';
        resultEl.hidden = false;
      }

      quizEl.addEventListener('click', function (e) {
        var restartBtn = e.target.closest('[data-quiz-restart]');
        if (restartBtn) {
          resultEl.hidden = true;
          if (group === 'hormonal' && nattyStep) nattyStep.hidden = false;
          else goalStep.hidden = false;
          return;
        }
        var answerBtn = e.target.closest('[data-quiz-answer]');
        if (!answerBtn) return;
        var stepEl = answerBtn.closest('[data-quiz-step]');
        if (!stepEl) return;
        var step = stepEl.getAttribute('data-quiz-step');
        var answer = answerBtn.getAttribute('data-quiz-answer');

        if (step === 'natty') {
          if (answer === 'natural') {
            showResult(
              "Sounds like you're keeping it natural right now - that's completely fine! " +
                productName +
                ' is a performance-enhancing compound, so it\'s probably not the right fit today. Our <a href="/products/creatine-monohydrate">Creatine</a> or <a href="/collections/protein">Whey Protein</a> ranges may suit you better - try the <a href="/pages/quiz">free product quiz</a>.'
            );
          } else {
            if (nattyStep) nattyStep.hidden = true;
            goalStep.hidden = false;
          }
          return;
        }

        if (step === 'goal') {
          var pctPairing =
            ' Consider pairing it with <a href="/products/recharge">Recharge</a> (PCT) once your cycle is done.';
          var copies = {
            bulking:
              'Good fit - ' +
              productName +
              ' is popular with people focused on bulking.' +
              (pctNeeded ? pctPairing : " It's non-suppressive, so no PCT is needed."),
            cutting:
              'Good fit - ' +
              productName +
              ' works well alongside a cutting goal.' +
              (pctNeeded ? pctPairing : " It's non-suppressive, so no PCT is needed."),
            recovery:
              'Good fit - ' +
              productName +
              ' is a strong match for recovery-focused goals. Check the product accordion for format and purity details.',
            metabolic:
              'Good fit - ' +
              productName +
              ' is researched for metabolic pathway support.',
            wellness:
              'Good fit - ' + productName + ' is a great everyday addition to your routine.',
            energy:
              'Good fit - ' +
              productName +
              ' is popular with people looking for an energy and performance boost.',
          };
          showResult(
            copies[answer] ||
              'Good fit - ' + productName + ' matches what you are after.'
          );
        }
      });
    });
  }

  /** PDP SEO FAQ tab switcher */
  function initPdpSeoFaq(root) {
    (root || document).querySelectorAll('[data-pdp-seo-faq]').forEach(function (faqRoot) {
      if (faqRoot.dataset.bound) return;
      faqRoot.dataset.bound = '1';
      var tabs = Array.prototype.slice.call(faqRoot.querySelectorAll('[data-pdp-faq-tab]'));
      var panels = Array.prototype.slice.call(faqRoot.querySelectorAll('[data-pdp-faq-panel]'));
      function activate(key) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-pdp-faq-tab') === key;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-pdp-faq-panel') === key;
          p.classList.toggle('is-active', on);
          if (on) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          activate(t.getAttribute('data-pdp-faq-tab'));
        });
      });
    });
  }

  function trimGalleryToProductMedia(mainEl) {
    var mediaRoot = mainEl.closest('.featured-media') || mainEl.parentElement;
    if (!mediaRoot) return;
    var count = parseInt(mediaRoot.getAttribute('data-media-count') || '0', 10);
    if (!count) return;
    function trim(el) {
      if (!el) return;
      var wrap = el.querySelector('.swiper-wrapper');
      if (!wrap) return;
      var slides = wrap.querySelectorAll(':scope > .swiper-slide');
      for (var i = slides.length - 1; i >= count; i--) {
        slides[i].parentNode.removeChild(slides[i]);
      }
    }
    trim(mainEl);
    trim(mediaRoot.querySelector('[data-pdp-thumbs]'));
  }

  function appendStoryImagesToGallery(mainEl) {
    return;
    var wrap = mainEl.querySelector('.swiper-wrapper');
    if (!wrap) return;
    var existing = {};
    Array.prototype.forEach.call(mainEl.querySelectorAll('img'), function (img) {
      var src = img.getAttribute('src') || '';
      var name = src.split('?')[0].split('/').pop();
      if (name) existing[name] = true;
    });
    var mediaRoot = mainEl.closest('.featured-media') || mainEl.parentElement;
    var thumbsEl = mediaRoot ? mediaRoot.querySelector('[data-pdp-thumbs]') : null;
    var thumbsWrap = thumbsEl ? thumbsEl.querySelector('.swiper-wrapper') : null;
    Array.prototype.forEach.call(storyImgs, function (img) {
      var src = img.currentSrc || img.src || '';
      var name = src.split('?')[0].split('/').pop();
      if (!src || !name || existing[name]) return;
      existing[name] = true;
      var alt = (img.getAttribute('alt') || '').replace(/"/g, '');
      var slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.innerHTML =
        '<img src="' +
        src +
        '" alt="' +
        alt +
        '" width="1400" height="1400" loading="lazy" decoding="async">';
      wrap.appendChild(slide);
      if (thumbsWrap) {
        var thumb = document.createElement('div');
        thumb.className = 'swiper-slide';
        thumb.setAttribute('role', 'button');
        thumb.tabIndex = 0;
        thumb.innerHTML =
          '<img src="' +
          src +
          '" alt="' +
          alt +
          '" width="160" height="160" loading="lazy" decoding="async">';
        thumbsWrap.appendChild(thumb);
      }
    });
  }

  /**
   * PDP image gallery - demos Swiper main (drag/swipe) + thumbs rail.
   * Markup: .swiper.pdp-gallery-main[data-pdp-gallery] + optional [data-pdp-thumbs].
   * Retries until Swiper CDN is ready (defer script order).
   */
  function initPdpGallery(attempt) {
    attempt = attempt || 0;
    if (typeof Swiper === 'undefined') {
      if (attempt < 50) setTimeout(function () { initPdpGallery(attempt + 1); }, 50);
      return;
    }
    document.querySelectorAll('[data-pdp-gallery]').forEach(function (mainEl) {
      if (mainEl.dataset.swiperInit) return;
      trimGalleryToProductMedia(mainEl);
      var slides = mainEl.querySelectorAll('.swiper-slide');
      if (!slides.length) return;
      mainEl.dataset.swiperInit = '1';

      var mediaRoot = mainEl.closest('.featured-media') || mainEl.parentElement;
      var thumbsEl = mediaRoot ? mediaRoot.querySelector('[data-pdp-thumbs]') : null;
      var thumbsSwiper = null;

      if (thumbsEl && thumbsEl.querySelectorAll('.swiper-slide').length > 1) {
        if (!thumbsEl.dataset.swiperInit) {
          thumbsEl.dataset.swiperInit = '1';
          thumbsSwiper = new Swiper(thumbsEl, {
            direction: 'vertical',
            slidesPerView: 'auto',
            spaceBetween: 8,
            watchSlidesProgress: true,
            freeMode: true,
            grabCursor: true,
            breakpoints: {
              0: {
                direction: 'horizontal',
                slidesPerView: 'auto',
                spaceBetween: 8,
              },
              801: {
                direction: 'vertical',
                slidesPerView: 'auto',
                spaceBetween: 8,
              },
            },
          });
        } else if (thumbsEl.swiper) {
          thumbsSwiper = thumbsEl.swiper;
        }
      }

      var mainSwiper = new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 320,
        grabCursor: true,
        allowTouchMove: true,
        simulateTouch: true,
        touchRatio: 1,
        threshold: 5,
        resistanceRatio: 0.85,
        watchOverflow: true,
        pagination: {
          el: mainEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
      });

      // Store for colour swatches / variant media hooks
      mainEl.swiper = mainSwiper;
    });
  }

  /* Cart items box shouldn't force-fill the drawer (Harry 2026-08-05:
     "missing recommended products closer bit" — the "You might also like"
     block was floating far below a short cart with a big empty gap).
     #CartDrawer-CartItems is a flex item inside <cart-drawer-items>; several
     duplicate same-specificity !important CSS rules across bridge.css/
     hotfix.css all declare `flex: 1 1 auto` on the exact same selector, and
     a CSS-only override kept losing that tie (confirmed via CDP matched-
     styles: my override rule WAS present and matched, computed flex-grow
     still came out 1) — some other identical-specificity duplicate keeps
     winning in a way that doesn't track with visible file/document order.
     Set it directly as an inline style instead: that always wins over any
     stylesheet rule, regardless of how many duplicates exist. */
  function initCartItemsFlexFix() {
    function apply() {
      var box = document.getElementById('CartDrawer-CartItems');
      if (box) box.style.setProperty('flex', '0 1 auto', 'important');
      var drawerItems = document.querySelector('cart-drawer-items');
      if (drawerItems) drawerItems.style.setProperty('overflow-y', 'auto', 'important');
    }
    apply();
    /* <cart-drawer-items> itself gets destroyed and recreated on every cart
       AJAX update (renderContents replaces #CartDrawer's whole subtree) —
       same trap as the cart-icon guard above. Observe <cart-drawer>, the
       one ancestor that's never itself replaced, only its descendants. */
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__aphFlexGuarded) return;
    drawer.__aphFlexGuarded = true;
    var mo = new MutationObserver(apply);
    mo.observe(drawer, { childList: true, subtree: true });
  }

  /* Cart icon self-heal (Harry 2026-08-05): several cart AJAX code paths
     (Dawn's stock CartItems.updateQuantity, quick-add-bulk.js,
     quick-order-list.js) blind-replace `#cart-icon-bubble`'s innerHTML with
     the fetched `cart-icon-bubble` section's OWN markup — which is still
     Dawn's original icon-cart.svg + .cart-count-bubble, never converted to
     the APH bag SVG + .bag-count badge. Whichever of those paths fires after
     a qty change swaps our icon for Dawn's mismatched one (looks like a
     broken/blank icon since no APH CSS targets .cart-count-bubble). Rather
     than patch every call site, watch the bubble and repair it on sight —
     catches this from any current or future caller. */
  function initCartIconGuard() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || bubble.__aphIconGuarded) return;
    bubble.__aphIconGuarded = true;

    var APH_BAG_SVG =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="none" stroke="currentColor" stroke-width="16" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="32" y="48" width="192" height="160" rx="8"></rect><path d="M168,88a40,40,0,0,1-80,0"></path></svg>';

    function currentCount() {
      var dawnCount = bubble.querySelector('.cart-count-bubble span[aria-hidden]');
      if (dawnCount) return (dawnCount.textContent || '').trim();
      var badge = bubble.querySelector('.bag-count, .cart-count');
      return badge ? (badge.textContent || '').trim() : null;
    }

    function repair() {
      var isDawnMarkup = !!bubble.querySelector('.cart-count-bubble');
      var isMissingBagIcon = !bubble.querySelector('svg rect');
      if (!isDawnMarkup && !isMissingBagIcon) return;
      var count = currentCount();
      bubble.innerHTML = APH_BAG_SVG;
      if (count && count !== '0') {
        var badge = document.createElement('span');
        badge.className = 'bag-count cart-count';
        badge.setAttribute('aria-hidden', 'true');
        badge.textContent = count;
        bubble.appendChild(badge);
      }
    }

    var mo = new MutationObserver(repair);
    mo.observe(bubble, { childList: true, subtree: true });
  }

  /* Cart line-price odometer (Harry 2026-08-05: "odometer on line price +
     subtotal... digit-reel, not a plain counter"). The subtotal already
     animates (cart-drawer.js calls APH.animatePrice directly), but every qty
     change/remove replaces the WHOLE items container with fresh server HTML
     — so each line's own price just flat-snaps to the new text with no
     transition. Rather than fork Dawn's private updateQuantity internals
     (2 different call sites — drawer qty change and the /cart page — both
     inherit it unmodified from cart.js), watch the container and replay the
     roll ourselves: remember each row's last price, and when a mutation
     lands a new value for a row we've already seen, animate old -> new. */
  function initCartPriceOdometer() {
    [
      /* Observe the outermost STABLE host, not the row container itself —
         every update path (add, qty change, remove) fully innerHTML-replaces
         #CartDrawer-CartItems as a brand-new node, so a MutationObserver
         bound to that node would stop firing after the very first replace.
         <cart-drawer> and #main-cart-items are never themselves swapped,
         only their descendants — safe to observe long-term. */
      { root: 'cart-drawer', rowPrefix: 'CartDrawer-Item-' },
      { root: '#main-cart-items', rowPrefix: 'CartItem-' },
    ].forEach(function (cfg) {
      var container = document.querySelector(cfg.root);
      if (!container || container.__aphOdometerGuarded) return;
      container.__aphOdometerGuarded = true;
      var lastSeen = {};
      var applying = false;

      function syncOne(key, priceEl) {
        if (!priceEl) return;
        /* Once odometerized, textContent is the digit-strip's full 0-9
           markup, not the visible number — read back data-gbp (which
           animatePrice keeps in sync) instead. Fresh server-rendered
           rows have no data-gbp yet, so fall back to the plain text. */
        var newVal = priceEl.hasAttribute('data-gbp')
          ? parseFloat(priceEl.getAttribute('data-gbp'))
          : parseFloat((priceEl.textContent || '').trim().replace(/[^0-9.]/g, ''));
        if (isNaN(newVal)) return;
        var prev = lastSeen[key];
        if (prev != null && Math.abs(prev - newVal) > 0.001) {
          priceEl.setAttribute('data-gbp', prev.toFixed(2));
          priceEl._odValue = prev;
          window.APH.animatePrice(priceEl, newVal);
        }
        lastSeen[key] = newVal;
      }

      function sync() {
        if (applying || !window.APH || typeof window.APH.animatePrice !== 'function') return;
        applying = true;
        try {
          container.querySelectorAll('[id^="' + cfg.rowPrefix + '"]').forEach(function (row) {
            syncOne(row.id, row.querySelector('.cart-item__line-price, .cart-item__final-price'));
          });
          /* Subtotal (Harry 2026-08-05: "the subtotal in cart should also
             have the odometer") — cart-drawer.js's own animatePrice call
             only fires on the add-to-cart flow; qty-change/remove go
             through Dawn's inherited updateQuantity, which just replaces
             this element with plain server-rendered text, no odometer.
             Same self-heal approach as the line prices above catches it
             regardless of which path triggered the change. */
          syncOne('subtotal', container.querySelector('.aph-cart-subtotal-value, [data-cart-subtotal]'));
        } finally {
          applying = false;
        }
      }

      var mo = new MutationObserver(function () {
        if (applying) return;
        sync();
      });
      mo.observe(container, { childList: true, subtree: true, characterData: true });
      sync();
    });
  }

  /* DAB-12 (2026-08-22): "cart shows $, not £" - the shop's actual Shopify
     currency IS USD (confirmed via /cart.js: {"currency":"USD"}), so Dawn's
     stock `money`/`money_with_currency` filters on the cart page + drawer
     render real "$"/"USD" output. Everywhere else on the site (product
     cards, PDPs) never shows that raw filter output - it displays a
     `.cur-price[data-gbp]` element instead, which window.APH.currency
     renders with the picker's symbol (£ by default, rate 1 - a label swap,
     not a real conversion; e.g. a card's data-gbp="29.99" reads "£29.99",
     same number the cart shows as "$29.99"). Cart/drawer money markup was
     never wired into that convention. Same fix, applied to cart's own
     leaf price/total nodes: swap the "$29.99 USD"-style text for the
     current currency symbol, matching how the rest of the site already
     reads. Numbers are untouched - this only relabels, same as everywhere
     else already does. */
  function relabelCartMoney(container) {
    var symbol = (window.APH.currency && window.APH.currency.symbol) || '£';
    var selector = [
      '.cart-item__final-price',
      '.cart-item__old-price',
      '.cart-item__line-price',
      '.cart-item__price-wrapper .price',
      '.cart-item__unit-price .price',
      '.product-option',
      '.aph-cart-totals-row span:last-child',
      '.totals__total-value',
      '.discounts__discount',
    ].join(',');
    container.querySelectorAll(selector).forEach(function (el) {
      if (el.hasAttribute('data-gbp') || el.querySelector('[data-gbp]')) return;
      /* Anchored to the FULL text (^...$), and skipped when already in the
         clean target shape - textContent replaces the child text node even
         when the new value is byte-identical to the old one, so without
         this idempotency check every write re-triggers the MutationObserver
         below and spins forever (found live: /cart hung, never reached
         domcontentloaded). */
      /* Dawn's own money spans are formatted with surrounding newlines/
         indentation in the source (e.g. cart-item__totals's `.price--end`),
         so the anchored match needs the trimmed text - matching untrimmed
         would just silently never match and skip every one of these. */
      var m = el.textContent.trim().match(/^([$£€])\s?([\d,]+\.\d{2})(\s?[A-Z]{3})?$/);
      if (!m || (m[1] === symbol && !m[3])) return;
      el.textContent = symbol + m[2];
    });
  }

  function initCartCurrencyLabel() {
    ['cart-drawer', '#main-cart-items', '#main-cart-footer'].forEach(function (rootSel) {
      var container = document.querySelector(rootSel);
      if (!container || container.__aphCurrencyGuarded) return;
      container.__aphCurrencyGuarded = true;
      var applying = false;
      function run() {
        if (applying) return;
        applying = true;
        try {
          relabelCartMoney(container);
        } finally {
          applying = false;
        }
      }
      var mo = new MutationObserver(run);
      mo.observe(container, { childList: true, subtree: true, characterData: true });
      run();
    });
  }

  /* Harry 2026-08-08: "add to cart needs price on it too - like add to
     cart - {price}" - the live-total pattern already existed but only ran
     on products with a cycle_upsell block (initPdpCycleUpsell below, the
     RAD-140 PCT toggle). Every other product's ATC button just said plain
     static "Add to cart". Same math (unit price × qty, no upsell add-on),
     scoped to buy boxes that do NOT have a cycle-upsell row - those get
     the richer version below instead (which also folds in the upsell
     price), so the two never double-bind the same button. */
  function initAtcLiveTotal(root) {
    (root || document).querySelectorAll('.featured-cta-row').forEach(function (buyBox) {
      if (buyBox.__aphAtcTotalBound) return;
      var addBtn = buyBox.querySelector('[data-aph-atc]');
      if (!addBtn) return;
      buyBox.__aphAtcTotalBound = true;

      function update() {
        if (window.APH && typeof window.APH.refreshAtcLabels === 'function') {
          window.APH.refreshAtcLabels();
          return;
        }
        var section = buyBox.closest('.shopify-section') || document;
        var qtyValueEl = buyBox.querySelector('.qty-value, [data-qty-value]');
        var mainPriceEl = section.querySelector('[data-aph-price] .cur-price[data-gbp]');
        if (!mainPriceEl || !qtyValueEl) return;
        var qty = parseInt(qtyValueEl.textContent, 10) || 1;
        var unit = parseFloat(mainPriceEl.getAttribute('data-unit-gbp'));
        if (isNaN(unit)) unit = parseFloat(mainPriceEl.getAttribute('data-gbp')) || 0;
        var total = Math.round(unit * qty * 100) / 100;
        var upsellRow = section.querySelector('[data-pdp-cycle-upsell]');
        var upsellBox = upsellRow && upsellRow.querySelector('[data-upsell-toggle]');
        if (upsellBox && upsellBox.checked) {
          total = Math.round((total + (parseFloat(upsellRow.getAttribute('data-upsell-price-gbp')) || 0)) * 100) / 100;
        }
        if (window.APH && typeof window.APH.setAtcLabel === 'function') {
          window.APH.setAtcLabel(addBtn, total);
        }
      }
      var stepper = buyBox.querySelector('[data-qty-stepper]');
      if (stepper) stepper.addEventListener('aph:qty', update);
      document.querySelectorAll('.bulk-tiers').forEach(function (group) {
        group.addEventListener('bulk-tier-change', update);
      });
      update();
    });
  }

  /* "Complete your cycle" PCT upsell toggle (Harry 2026-08-05). The visual
     checked/unchecked state is class-based (.upsell-row--on / --pct-off),
     not :has(:checked), so a restored checkbox cannot paint green. This
     still does the real work: when the shopper submits the main product
     form with the toggle on, also add the upsell product as a second cart
     line. Fires independently of (not chained to) the main form's own
     add-to-cart request — both responses include the full current cart
     sections, so whichever resolves last renders the accurate combined
     cart regardless of which request Shopify's backend processes first. */
  function initPdpCycleUpsell(root) {
    (root || document).querySelectorAll('[data-pdp-cycle-upsell]').forEach(function (row) {
      if (row.__aphCycleUpsellBound) return;
      row.__aphCycleUpsellBound = true;

      var checkbox = row.querySelector('[data-upsell-toggle]');
      var variantId = row.getAttribute('data-upsell-variant-id');
      var upsellPrice = parseFloat(row.getAttribute('data-upsell-price-gbp')) || 0;
      var pctRequired = row.getAttribute('data-pct-required') === 'true';
      if (!checkbox || !variantId) return;

      /* Red "you should run a PCT" alert (Harry 2026-08-06: was missing —
         only the CSS/class existed, no element to show). Only relevant
         when this specific block is flagged pct_required in the customizer
         — a plain bundle upsell (pct_required off) never shows it. */
      var alertEl =
        row.nextElementSibling && row.nextElementSibling.hasAttribute('data-upsell-alert')
          ? row.nextElementSibling
          : null;

      function forceOff() {
        checkbox.checked = false;
        checkbox.defaultChecked = false;
        checkbox.removeAttribute('checked');
      }

      function syncVisual() {
        var on = checkbox.checked;
        row.classList.toggle('upsell-row--pct-off', !on);
        row.classList.toggle('upsell-row--on', on);
        if (alertEl) alertEl.classList.toggle('is-visible', pctRequired && !on);
        var copyEl = row.querySelector('[data-upsell-copy-off]');
        if (copyEl) {
          copyEl.textContent = on
            ? copyEl.getAttribute('data-upsell-copy-on') || copyEl.textContent
            : copyEl.getAttribute('data-upsell-copy-off') || copyEl.textContent;
        }
        var lab = row.querySelector('.upsell-toggle-label');
        if (lab) {
          lab.textContent = on
            ? lab.getAttribute('data-label-on') || 'Included'
            : lab.getAttribute('data-label-off') || 'Add';
        }
      }
      forceOff();
      syncVisual();
      function updateAtcTotal() {
        var section = row.closest('.shopify-section') || document;
        var btn =
          section.querySelector('.featured-cta-row [data-aph-atc]') ||
          document.querySelector('[data-aph-atc]');
        if (!btn) {
          if (window.APH && typeof window.APH.refreshAtcLabels === 'function') {
            window.APH.refreshAtcLabels();
          }
          return;
        }
        var buyBox = btn.closest('.featured-cta-row') || section;
        var qtyValueEl = buyBox.querySelector('.qty-value, [data-qty-value]');
        var mainPriceEl =
          section.querySelector('[data-aph-price] .cur-price[data-gbp]') ||
          section.querySelector('[data-aph-price] [data-gbp]');
        var qty = qtyValueEl ? parseInt(qtyValueEl.textContent, 10) || 1 : 1;
        var unit = 0;
        if (mainPriceEl) {
          unit = parseFloat(mainPriceEl.getAttribute('data-unit-gbp'));
          if (isNaN(unit)) unit = parseFloat(mainPriceEl.getAttribute('data-base-gbp'));
          if (isNaN(unit)) unit = parseFloat(mainPriceEl.getAttribute('data-gbp')) || 0;
        }
        var pence = Math.round(unit * 100) * qty;
        if (checkbox.checked) pence += Math.round(upsellPrice * 100);
        if (window.APH && typeof window.APH.setAtcLabel === 'function') {
          window.APH.setAtcLabel(btn, pence / 100);
        }
        if (window.APH && typeof window.APH.refreshAtcLabels === 'function') {
          window.APH.refreshAtcLabels();
        }
      }
      checkbox.addEventListener('change', function () {
        row.__aphCycleUserOn = checkbox.checked;
        syncVisual();
        updateAtcTotal();
      });
      row.addEventListener('click', function () {
        setTimeout(function () {
          row.__aphCycleUserOn = checkbox.checked;
          syncVisual();
          updateAtcTotal();
        }, 0);
      });
      window.addEventListener('pageshow', function () {
        if (row.__aphCycleUserOn) return;
        forceOff();
        syncVisual();
        updateAtcTotal();
      });

      var section = row.closest('.shopify-section') || document;
      var form = section.querySelector('form.aph-product-form, form[data-type="add-to-cart-form"]');
      var buyBox = section.querySelector('.featured-cta-row');
      if (buyBox) {
        var stepper = buyBox.querySelector('[data-qty-stepper]');
        if (stepper) stepper.addEventListener('aph:qty', updateAtcTotal);
      }
      document.querySelectorAll('.bulk-tiers').forEach(function (group) {
        group.addEventListener('bulk-tier-change', updateAtcTotal);
      });
      updateAtcTotal();

      if (!form) return;
      /* One /cart/add.js with product + Recharge when the toggle is on.
         A second add after the product is the lag Harry saw. */
      if (window.APH && typeof window.APH.addToCart === 'function' && !window.APH.__cycleUpsellChained) {
        window.APH.__cycleUpsellChained = true;
        var origAdd = window.APH.addToCart;
        window.APH.addToCart = function (formOrData) {
          if (formOrData && formOrData.__aphUpsell) {
            return origAdd({ id: formOrData.id, quantity: formOrData.quantity || 1 });
          }
          var addedId = '';
          var qty = 1;
          if (formOrData && formOrData.items && formOrData.items[0]) {
            addedId = String(formOrData.items[0].id || '');
            qty = parseInt(formOrData.items[0].quantity, 10) || 1;
          } else if (formOrData && formOrData.id) {
            addedId = String(formOrData.id);
            qty = parseInt(formOrData.quantity, 10) || 1;
          } else if (typeof FormData !== 'undefined' && formOrData instanceof FormData) {
            addedId = String(formOrData.get('id') || '');
            qty = parseInt(formOrData.get('quantity') || '1', 10) || 1;
          }
          var liveRow = document.querySelector('[data-pdp-cycle-upsell]');
          var liveBox = liveRow && liveRow.querySelector('[data-upsell-toggle]');
          var liveVid = liveRow && liveRow.getAttribute('data-upsell-variant-id');
          var pdpForm = document.querySelector('form.aph-product-form, form[data-type="add-to-cart-form"]');
          var pdpVid = pdpForm && pdpForm.querySelector('[name="id"]');
          if (
            liveBox &&
            liveBox.checked &&
            !liveBox.disabled &&
            liveVid &&
            addedId &&
            String(addedId) !== String(liveVid) &&
            (!pdpVid || String(pdpVid.value) === addedId)
          ) {
            return origAdd({
              items: [
                { id: parseInt(addedId, 10), quantity: qty },
                { id: parseInt(liveVid, 10), quantity: 1 },
              ],
            });
          }
          return origAdd(formOrData);
        };
      }
    });
  }

  function initSortPicker(root) {
    var scope = root || document;
    var pickers = scope.querySelectorAll('[data-sort-picker]');
    pickers.forEach(function (picker) {
      if (picker.dataset.sortPickerInit) return;
      picker.dataset.sortPickerInit = 'true';

      var trigger = picker.querySelector('.sort-trigger');
      var list = picker.querySelector('.sort-options');
      var nativeSelect = picker.querySelector('[data-sort-select]');
      if (!trigger || !list) return;

      function close() {
        picker.classList.remove('open');
        trigger.setAttribute('aria-expanded', 'false');
        list.hidden = true;
      }
      function open() {
        picker.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
        list.hidden = false;
      }

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (picker.classList.contains('open')) close();
        else open();
      });

      document.addEventListener('click', function (e) {
        if (!picker.contains(e.target)) close();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });

      list.querySelectorAll('[data-sort-value]').forEach(function (li) {
        li.addEventListener('click', function () {
          var url = li.getAttribute('data-sort-value');
          if (nativeSelect) nativeSelect.value = url;
          if (url) window.location.href = url;
        });
      });

      if (nativeSelect) {
        nativeSelect.addEventListener('change', function () {
          if (nativeSelect.value) window.location.href = nativeSelect.value;
        });
      }
    });
  }

  /* DAB-24: kill the free-quiz sticky. Chat launcher with Track order +
     Help. Quiz lives as a homepage card (aph-quiz-card), not a float. */
  function initQuizStickyCta() {
    document.querySelectorAll('[data-quiz-sticky], .quiz-sticky-cta').forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  }

  function initHelpChat() {
    var path = (location.pathname || '').toLowerCase();
    if (path.indexOf('/cart') !== -1) return;
    var wrap = document.querySelector('[data-aph-help-chat]');
    if (!wrap) return;
    var fab = wrap.querySelector('.aph-help-chat-fab');
    var panel = wrap.querySelector('.aph-help-chat-panel');
    if (!fab || !panel) return;
    fab.addEventListener('click', function () {
      var open = wrap.classList.toggle('is-open');
      fab.setAttribute('aria-expanded', open ? 'true' : 'false');
      fab.setAttribute('aria-label', open ? 'Close help' : 'Open help');
      if (open) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });
    var chatLink = wrap.querySelector('[data-aph-open-chat]');
    if (chatLink) {
      chatLink.addEventListener('click', function (e) {
        var inbox = document.querySelector('#ShopifyChat, shop-chat, .shopify-chat, iframe[title*="chat" i]');
        if (inbox) {
          e.preventDefault();
          var btn = document.querySelector('button[aria-label*="chat" i], #ShopifyChat button');
          if (btn) btn.click();
        }
      });
    }
  }

  /* Harry 2026-08-08: "on mobile only put the best sellers/bulking chips
     underneath hero. leave desktop as is" - chips currently render before
     the hero in every breakpoint (plain block flow, no flex on #MainContent
     to reorder via CSS `order` without risking every other section's
     layout). Move the chips DOM node itself, scoped to just these two
     elements, so nothing else on the page is touched. */
  function initMobileChipsBelowHero() {
    var chips = document.querySelector('[id^="AphChips-"]');
    var hero = document.querySelector('[id^="AphHero-"]');
    if (!chips || !hero || chips.parentNode !== hero.parentNode) return;
    var parent = chips.parentNode;
    var originalNextSibling = chips.nextSibling;
    var mq = window.matchMedia('(max-width: 800px)');
    function apply(e) {
      if (e.matches) {
        hero.insertAdjacentElement('afterend', chips);
      } else if (originalNextSibling) {
        parent.insertBefore(chips, originalNextSibling);
      } else {
        parent.appendChild(chips);
      }
    }
    apply(mq);
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply); // Safari <14 fallback
  }

  /**
   * Harry 2026-08-09: cart + search drawers should blur the page behind
   * them without visually darkening/blurring the site header - "nothing
   * should disappear, the cart should just appear over the top". The
   * drawer overlay + panel live inside <cart-drawer>, which already sets
   * its own z-index:10050 and creates an isolated stacking context - its
   * children (overlay, panel) only ever stack against each other, never
   * against the header directly, so no combination of z-index values on
   * the overlay/header/panel can sandwich the header between the blur
   * layer and the panel. Simplest correct fix: keep the overlay from
   * covering the header's own screen region at all, via a top offset
   * equal to the header's actual rendered height (promo bar + nav row
   * combined, which changes with viewport width and whether the promo
   * bar is present) - see aph-hotfix.css `top: var(--aph-header-h)` on
   * .cart-drawer__overlay / .search-overlay.
   */
  function initHeaderHeightVar() {
    var group = document.querySelector('.shopify-section-group-header-group');
    if (!group) return;

    function measure() {
      // Promo bar + nav row are separate .shopify-section-group-header-group
      // instances stacked at the top - sum every one of them for the total
      // header block height, and also record the promo bar's own height
      // separately so the scroll-lock fix (aph-hotfix.css) can offset the
      // nav row to sit BELOW the promo bar instead of on top of it.
      var groups = document.querySelectorAll('.shopify-section-group-header-group');
      var total = 0;
      var promoH = 0;
      groups.forEach(function (el) {
        var h = el.getBoundingClientRect().height;
        total += h;
        if (el.classList.contains('section-aph-promo')) promoH = h;
      });
      if (total > 0) {
        document.documentElement.style.setProperty('--aph-header-h', total + 'px');
      }
      document.documentElement.style.setProperty('--aph-promo-h', promoH + 'px');
    }

    var resizeTimer;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measure, 150);
    }

    measure();
    window.addEventListener('resize', onResize);
    // Promo bar swiper / currency picker can change height post-load.
    window.addEventListener('load', measure);
  }

  /* Harry 2026-08-18: generic "this page isn't built yet" popup for any
     placeholder / not-yet-real destination card sitewide (data-unbuilt),
     starting with the 4 blog "coming soon" cards on /blogs/news. Delegated
     click listener so it works for cards added later (theme editor section
     reloads, future re-uses) without re-initialising - guarded so boot()
     running again (shouldn't, but section:load safety) doesn't double-bind. */
  var unbuiltPopupInited = false;
  var unbuiltPopupEl = null;
  function ensureUnbuiltPopup() {
    if (unbuiltPopupEl) return unbuiltPopupEl;
    var el = document.createElement('div');
    el.className = 'aph-unbuilt-popup';
    el.setAttribute('hidden', '');
    el.innerHTML =
      '<div class="aph-unbuilt-popup-overlay" data-unbuilt-close></div>' +
      '<div class="aph-unbuilt-popup-card" role="dialog" aria-modal="true" aria-labelledby="aph-unbuilt-popup-msg">' +
        '<button type="button" class="aph-unbuilt-popup-close" data-unbuilt-close aria-label="Close">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="16" height="16" aria-hidden="true"><line x1="200" y1="56" x2="56" y2="200" stroke="currentColor" stroke-linecap="round" stroke-width="16"/><line x1="200" y1="200" x2="56" y2="56" stroke="currentColor" stroke-linecap="round" stroke-width="16"/></svg>' +
        '</button>' +
        '<p id="aph-unbuilt-popup-msg">This page isn’t built yet.</p>' +
      '</div>';
    document.body.appendChild(el);
    unbuiltPopupEl = el;
    return el;
  }
  function openUnbuiltPopup(message) {
    var el = ensureUnbuiltPopup();
    el.querySelector('#aph-unbuilt-popup-msg').textContent = message || "This page isn’t built yet.";
    el.removeAttribute('hidden');
    document.body.classList.add('overflow-hidden');
  }
  function closeUnbuiltPopup() {
    if (unbuiltPopupEl) unbuiltPopupEl.setAttribute('hidden', '');
    document.body.classList.remove('overflow-hidden');
  }
  function initUnbuiltPopup() {
    if (unbuiltPopupInited) return;
    unbuiltPopupInited = true;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-unbuilt-close]')) {
        closeUnbuiltPopup();
        return;
      }
      var trigger = e.target.closest('[data-unbuilt]');
      if (!trigger) return;
      e.preventDefault();
      openUnbuiltPopup(trigger.getAttribute('data-unbuilt-message'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && unbuiltPopupEl && !unbuiltPopupEl.hasAttribute('hidden')) closeUnbuiltPopup();
    });
  }

  /* Blog "coming soon" placeholder cards aren't real search results - keep
     them out of the way while a search query is active so results read
     cleanly, then bring them back once the box is cleared. */
  function initBlogPlaceholders(root) {
    var scope = root || document;
    var input = scope.querySelector ? scope.querySelector('[data-blog-search-input]') : null;
    if (!input) input = document.querySelector('[data-blog-search-input]');
    var grid = document.querySelector('[data-blog-grid]');
    if (!input || !grid) return;
    var placeholders = Array.prototype.slice.call(grid.querySelectorAll('.blog-card--placeholder'));
    if (!placeholders.length) return;
    function run() {
      var hasQuery = !!(input.value || '').trim();
      placeholders.forEach(function (card) { card.hidden = hasQuery; });
    }
    input.addEventListener('input', run);
    input.addEventListener('search', run);
    run();
  }

  /* Blog / Learn list - instant client-side filter (feels like AJAX, no
     round-trip). Ported from orphaned aph-design.js (never loaded) so typing
     in /blogs/news actually filters. Filters [data-blog-card] by the card's
     data-blog-search haystack; updates meta count + empty state + clear btn. */
  function initBlogSearch(root) {
    var scope = root || document;
    var input = scope.querySelector ? scope.querySelector('[data-blog-search-input]') : null;
    if (!input) input = document.querySelector('[data-blog-search-input]');
    var grid = document.querySelector('[data-blog-grid]');
    if (!input || !grid) return;
    if (input.getAttribute('data-aph-blog-filter-ready') === '1') return;
    input.setAttribute('data-aph-blog-filter-ready', '1');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-blog-card]'));
    var meta = document.querySelector('[data-blog-search-meta]');
    var empty = document.querySelector('[data-blog-search-empty]');
    var clearBtn = document.querySelector('[data-blog-search-clear]');
    var total = cards.length;
    function run() {
      var q = (input.value || '').trim().toLowerCase();
      var tokens = q ? q.split(/\s+/).filter(Boolean) : [];
      var shown = 0;
      cards.forEach(function (card) {
        var hay = (card.getAttribute('data-blog-search') || card.textContent || '').toLowerCase();
        var ok = !tokens.length || tokens.every(function (t) { return hay.indexOf(t) !== -1; });
        card.hidden = !ok;
        if (ok) shown++;
      });
      if (meta) {
        meta.textContent = tokens.length
          ? (shown + ' of ' + total + ' articles')
          : (total + ' articles');
      }
      if (empty) empty.hidden = shown !== 0;
      if (clearBtn) clearBtn.hidden = !q;
    }
    input.addEventListener('input', run);
    input.addEventListener('search', run);
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        input.focus();
        run();
      });
    }
    run();
  }

  function initCustomSelects(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    function closeAll(except) {
      document.querySelectorAll('[data-custom-select].is-open').forEach(function (el) {
        if (except && el === except) return;
        el.classList.remove('is-open');
        var trigger = el.querySelector('.custom-select-trigger');
        var list = el.querySelector('.custom-select-list');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (list) list.hidden = true;
      });
    }
    scope.querySelectorAll('[data-custom-select]').forEach(function (wrap) {
      if (wrap.getAttribute('data-aph-select-ready') === '1') return;
      wrap.setAttribute('data-aph-select-ready', '1');
      var trigger = wrap.querySelector('.custom-select-trigger');
      var list = wrap.querySelector('.custom-select-list');
      var label = wrap.querySelector('[data-custom-select-label]');
      var hidden = wrap.querySelector('input[type="hidden"]');
      if (!trigger || !list) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var willOpen = !wrap.classList.contains('is-open');
        closeAll(wrap);
        wrap.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        list.hidden = !willOpen;
      });
      list.querySelectorAll('[role="option"]').forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var value = opt.getAttribute('data-value') || opt.textContent.trim();
          var text = opt.textContent.trim();
          if (hidden) hidden.value = value;
          if (label) label.textContent = text;
          list.querySelectorAll('[role="option"]').forEach(function (o) {
            o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
          });
          closeAll();
        });
      });
    });
    if (!document.documentElement.getAttribute('data-aph-select-doc')) {
      document.documentElement.setAttribute('data-aph-select-doc', '1');
      document.addEventListener('click', function () { closeAll(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAll();
      });
    }
  }

  function initSchedulerSwipe() {
    /* A-hero-loop: banned go() wrap + translateX(0). Swiper loop owns the hero. */
  }

  function initSearchTypewriter(root) {
    var scope = root || document;
    var input = scope.querySelector ? scope.querySelector('[data-search-typewriter]') : null;
    if (!input) input = document.querySelector('[data-search-typewriter]');
    if (!input || input.getAttribute('data-aph-tw-ready') === '1') return;
    input.setAttribute('data-aph-tw-ready', '1');
    var prefix = input.getAttribute('data-search-typewriter-prefix') || 'Search ';
    var words = (input.getAttribute('data-search-typewriter-words') || 'RAD 140,Creatine Gummies,Alpha AF')
      .split(',')
      .map(function (w) { return w.trim(); })
      .filter(Boolean);
    if (!words.length) return;
    var wordIndex = 0;
    var charIndex = 0;
    var deleting = false;
    var timer;
    function tick() {
      if (document.activeElement === input || (input.value && input.value !== input.getAttribute('placeholder'))) {
        timer = setTimeout(tick, 800);
        return;
      }
      var word = words[wordIndex];
      if (!deleting) {
        charIndex += 1;
        input.setAttribute('placeholder', prefix + word.slice(0, charIndex));
        if (charIndex >= word.length) {
          deleting = true;
          timer = setTimeout(tick, 1400);
          return;
        }
        timer = setTimeout(tick, 70);
        return;
      }
      charIndex -= 1;
      input.setAttribute('placeholder', prefix + word.slice(0, Math.max(charIndex, 0)));
      if (charIndex <= 0) {
        deleting = false;
        wordIndex = (wordIndex + 1) % words.length;
        timer = setTimeout(tick, 280);
        return;
      }
      timer = setTimeout(tick, 40);
    }
    input.setAttribute('placeholder', prefix + words[0]);
    timer = setTimeout(tick, 900);
  }

  function initStickyAtc() {
    if (window.matchMedia && !window.matchMedia('(max-width: 749px)').matches) return;
    var wrap = document.querySelector('[data-aph-atc-wrap]');
    var form = document.querySelector('form.aph-product-form, form[data-type="add-to-cart-form"]');
    var atc = form && form.querySelector('[data-aph-atc], button[name="add"]');
    if (!wrap || !form || !atc) return;
    if (wrap.hasAttribute('hidden') || atc.disabled) return;
    if (document.querySelector('[data-aph-sticky-atc]')) return;

    var bar = document.createElement('div');
    bar.className = 'aph-sticky-atc';
    bar.setAttribute('data-aph-sticky-atc', '');
    bar.innerHTML =
      '<button type="button" class="btn-roll accent" data-aph-sticky-atc-btn>' +
      '<span class="btn-roll-wrap"><span class="btn-roll-inner"><span></span><span></span></span></span>' +
      '</button>';
    document.body.appendChild(bar);
    document.documentElement.classList.add('has-sticky-atc');

    var btn = bar.querySelector('[data-aph-sticky-atc-btn]');
    var stickySpans = btn.querySelectorAll('.btn-roll-inner > span');

    function syncLabel() {
      var src = atc.querySelectorAll('.btn-roll-inner > span');
      var text = src.length ? src[0].textContent : 'Add to cart';
      stickySpans.forEach(function (span) {
        span.textContent = text;
      });
    }

    function setVisible(on) {
      bar.classList.toggle('is-visible', !!on);
      document.documentElement.classList.toggle('sticky-atc-visible', !!on);
    }

    btn.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(atc);
      else atc.click();
    });

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        var drawerOpen = document.documentElement.classList.contains('cart-drawer-open');
        setVisible(!drawerOpen && entry && !entry.isIntersecting);
      },
      { threshold: 0.15 }
    );
    observer.observe(wrap);

    var mo = new MutationObserver(syncLabel);
    mo.observe(atc, { subtree: true, characterData: true, childList: true });
    syncLabel();

    var drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.__aphStickyAtcObs) {
      drawer.__aphStickyAtcObs = true;
      var dmo = new MutationObserver(function () {
        var open = drawer.classList.contains('active') || drawer.hasAttribute('open');
        if (open) setVisible(false);
      });
      dmo.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
    }
  }

  function initTestimonialsLabel() {
    /* Harry 2026-09-10: TESTIMONIALS / View all bar breaks PDP flow. Reviews stay as a section. */
    document.querySelectorAll('.aph-pdp-break--testimonials').forEach(function (el) {
      el.remove();
    });
  }

  function boot() {
    initHeaderHeightVar();
    initMobileChipsBelowHero();
    initQuizStickyCta();
    initHelpChat();
    initQtySteppers();
    initBulkTiers();
    initAccordions();
    initPromoSwiper();
    initPromoCodeCopy();
    initHeroSwiper();
    initBlogSwiper();
    initReviewsSwiper();
    initPdpGallery();
    initPdpQuiz();
    initTestimonialsLabel();
    initPdpSeoFaq();
    initAtcSpinner();
    initCardForms();
    initSearchDrawer();
    initScrollProgress();
    initAccountMenu();
    initSortPicker();
    initCartIconGuard();
    initCartPriceOdometer();
    initCartItemsFlexFix();
    initCartCurrencyLabel();
    initPdpCycleUpsell();
    initAtcLiveTotal();
    if (window.APH && typeof window.APH.refreshAtcLabels === 'function') {
      window.APH.refreshAtcLabels();
    }
    initStickyAtc();
    initUnbuiltPopup();
    initBlogPlaceholders();
    initBlogSearch();
    initCustomSelects();
    initSearchTypewriter();
    initSchedulerSwipe();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    initQtySteppers(e.target);
    initBulkTiers(e.target);
    initAccordions(e.target);
    initPromoSwiper(e.target);
    initPromoCodeCopy(e.target);
    initHeroSwiper();
    initBlogSwiper();
    initReviewsSwiper();
    initPdpGallery();
    initPdpQuiz(e.target);
    initPdpSeoFaq(e.target);
    initAtcSpinner();
    initCardForms();
    initSearchDrawer();
    initScrollProgress();
    initAccountMenu();
    initSortPicker(e.target);
    initPdpCycleUpsell(e.target);
    initAtcLiveTotal(e.target);
    initStickyAtc();
    initBlogPlaceholders(e.target);
    initBlogSearch(e.target);
    initCustomSelects(e.target);
    initSearchTypewriter(e.target);
    initSchedulerSwipe();
  });
})();
